export const DEFAULT_TABLE_PAGE_SIZE = 100;

export const TABLE_PAGE_SIZE_OPTIONS = [20, 50, 100, 200, 500] as const;

export const TABLE_PAGE_SIZE_LABEL = 'Rows per page';
